import exportFromJSON from './exportFromJSON';
export default exportFromJSON;
